<template>
  <TrfSimpleModal
    titulo="Aviso"
    :isAtivo="isAtivo"
    @close="fecharModal"
    :isModalPersonalizado="true"
  >
    <div
      id="conteudo-modal-permissao"
      class="modal-list-content px-5 pb-1 custom-y-scrollbar"
      style="
        height: 100%;
        max-height: 60vh;
        max-width: 1024px;
        width: 100%;
        overflow: auto;
      "
    >
      <div class="content">
        <p class="mt-4">
          <strong>{{ nomeUsuario }}</strong
          >, identificamos que você possui algumas tarefas sob sua
          responsabilidade de empresas e/ou departamentos nos quais não possui
          permissão.
        </p>
        <p>
          Por favor, verifique as permissões de seu usuário, pois essas tarefas
          não serão demonstradas na sua área caso você não tenha permissão.
        </p>
        <p v-if="this.dados.length > 1">
          As tarefas listadas abaixo encontram-se em aberto e nestas condições:
        </p>
        <p v-else>
          A tarefa listada abaixo encontra-se em aberto e nestas condições:
        </p>
      </div>
      <TrfSimpleTable
        mensagemSemDados="Nenhum dado encontrado."
        togglebleItem="fases"
        :configuracaoDeColunas="listagemConfiguracao"
        :dados="dados"
        :isCliente="false"
        :isSelectable="false"
        :hasSlotLine="false"
        :isToggleble="false"        
        :isMultipleSelection="false"
      >
        <template #nome="{item}">
          <p>{{ item.isFase ? item.nomeHistorico : item.nome }}</p>
          <p v-if="item.isFase" class="is-size-7"><i>Fase: {{ item.nome }}</i></p>
        </template>
      </TrfSimpleTable>
      <div v-if="isLoading">
        <span
          class="button is-large is-fullwidth is-loading trf-is-borderless"
        ></span>
      </div>
    </div>
  </TrfSimpleModal>
</template>
  
  <script>
import TrfSimpleModal from "../../../../components/Modal/TrfSimpleModal.vue";
import TrfSimpleTable from "../../../../components/SimpleTable";
import { service as historicoService } from "../../../../views/Dashboard/service/historico-tarefas-service";
import { pessoaLogada } from "../../../../stateManagement/pessoaLogada";
import { utils } from "../../../../util/utils";

export default {
  name: "TrfDashboardModalPermissao",
  emits: ['on-close'],
  components: {
    TrfSimpleModal,
    TrfSimpleTable,
  },
  data() {
    return {
      dados: [],
      isLoading: true,
      isClosed: false,
      listagemConfiguracao: [
        {
          titulo: "Nome da tarefa",
          referencia: ["nome"],
          divisor: "",
          customStyle: "width: 325px;",
          nome: 'nome',
          slot: true
        },
        {
          titulo: "Data de entrega",
          referencia: ["prazoEntrega"],
          divisor: "",
          customStyle: "width: 140px;",
        },
        {
          titulo: "Nome da empresa",
          referencia: ["nomeEmpresa"],
          divisor: "",
          customStyle: "width:255px;",
        },
        {
          titulo: "Departamento",
          referencia: ["nomeDepartamento"],
          divisor: "",
          customStyle: "width: 200px;",
        },
      ],
    };
  },
  computed: {
    isAtivo() {
      return this.dados.length > 0 && !this.isClosed;
    },
    nomeUsuario() {
      const nome = pessoaLogada.current.nome;
      return nome.trim();
    }
  },
  methods: {
    fecharModal() {
      this.isClosed = true;
      this.$emit("on-close", true);
    },
    async adquirirDados() {
      const tarefasSemPermissao = await historicoService.listarSemPermissao();

      const historicos = tarefasSemPermissao.historicos.map(item => this.getTarefaObj(item, false));
      const fases = tarefasSemPermissao.fases.map(item => this.getTarefaObj(item, true));

      this.dados = historicos.concat(fases);
      this.isLoading = false;
    },
    getTarefaObj(item, isFase) {
      return {
        ...item,
        prazoEntrega: utils.formatarDataParaExibicaoNoDataTable(item.prazoEntrega),
        isFase
      }
    }
  },
  async mounted() {
    await this.adquirirDados();
  },
};
</script>

<style lang="scss" scoped>
.columns.is-2 > .column {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
</style>
  